// Filterlogik für die Benutzerverwaltung — reine Funktion, damit sie ohne
// gerenderte Komponente testbar ist (Muster wie mailing-match.ts, selection.ts).

import type { ManagedUser, UserFilters } from '@/types';

/** Wendet Rollen- und E-Mail-Filter auf die geladene Nutzerliste an. */
export function filterUsers(users: ManagedUser[], filters: UserFilters): ManagedUser[] {
  const needle = filters.search?.trim().toLowerCase();

  return users.filter((u) => {
    if (filters.role && u.role !== filters.role) return false;
    if (needle && !u.email.toLowerCase().includes(needle)) return false;
    return true;
  });
}
